import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// On static hosting (Firebase), route /api/* calls to local API daemon on port 3456 if running,
// and gracefully fall back if unreachable.
(function guardApiCalls() {
  const hasBackend = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (hasBackend || window.__apiGuardInstalled) return;
  window.__apiGuardInstalled = true;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input?.url || '';
    if (/^\/api\//.test(url)) {
      try {
        return await nativeFetch(`http://localhost:3456${url}`, init);
      } catch (_) {
        return new Response(JSON.stringify({ error: 'No backend on static hosting' }), {
          status: 503,
          headers: { 'Content-Type': 'application/json' }
        });
      }
    }
    return nativeFetch(input, init);
  };
})();

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
